import * as React from "react";
import { Area } from "../../../models/Area";
import { AdminApiController } from "../../../models/AdminApiController.generated";
import { Button, Modal } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { AreaNode } from "./areaModels";
import { ErrorMessage as SilErrorMessage } from "../shared/ErrorMessage";
import { GetAreasResponse } from "../../../models/GetAreasResponse";
import { AreaWithProjectName } from "../../../models/AreaWithProjectName";

interface Props {
    area: Area;
    parent: Area;
    callback: ((areas: AreaWithProjectName[]) => void);
    mode: string;
}

interface State {
    show: boolean;
    upsertResponse: string;
}

export class AreaEditModal extends React.Component<Props, State> {
    constructor(props, context) {
        super(props, context);

        this.handleShow = this.handleShow.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false,
            upsertResponse: null
        };
    }

    //saves reference to submit form so it can be called from external component
    submitForm = null;
    bindSubmitForm(submitForm) {
        this.submitForm = submitForm;
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true, upsertResponse: null });
    }

    handleSave() {
        if (this.submitForm) {
            this.submitForm();
        }
    }

    handleSubmit(values: AreaNode, actions) {
        console.log({ values, actions });
        const scrubbedArea = { ...values };
        // remove circular references
        scrubbedArea.parent = null;
        scrubbedArea.children = null;
        const area = new Area();
        Object.assign(area, scrubbedArea);
        let result: Promise<GetAreasResponse>;
        if (this.props.mode === "edit") {

            result = AdminApiController.updateArea(area);
        } else {
            area.id = null;
            area.parentId = this.props.parent ? this.props.parent.id : null;
            result = AdminApiController.addArea(area);
        }
        result.then(resp => {
            if (resp.result) {
                this.props.callback(resp.areas);
                this.handleClose();
            } else {
                console.log("stateBefore");
                console.log(this.state);
                this.setState({ upsertResponse: resp.message }, () => {

                    console.log("stateAfter");
                    console.log(this.state);
                });
            }
        });

        actions.setSubmitting(false);
    }

    getLevel = item => {
        if (item == null) return;
        if (item.projectId) return "Project";
        if (item.unit) return "Unit";
        if (item.location) return "Location";
        if (item.region) return "Region";
        if (item.clientId) return "Client ID";
    };

    getAddLevel = item => {
        if (item == null) return;
        if (item.projectId) return "";
        if (item.unit) return "Project";
        if (item.location) return "Unit";
        if (item.region) return "Location";
        if (item.clientId) return "Region";
        if (this.props.mode === "new") return "Client ID";
    };

    render() {
        const editFieldName =
            this.props.mode === "edit"
                ? this.getLevel(this.props.area)
                : this.getAddLevel(this.props.area);

        return (
            <React.Fragment>
                <Button
                    className={"btn btn-" + this.props.mode}
                    variant="success"
                    onClick={this.handleShow}
                    disabled={
                        this.props.area == null
                        || (this.props.mode === "add" && this.props.parent == null)
                        || (this.props.mode === "add" && this.getLevel(this.props.area) === "Unit")
                        || this.getLevel(this.props.area) == "Project"
                    }
                >
                    {this.props.mode} {editFieldName}
                </Button>

                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.mode} Area {editFieldName}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Formik
                            initialValues={this.props.area ? this.props.area : {}}
                            onSubmit={(values, actions) => this.handleSubmit(values as any, actions)}
                        >
                            {formikBag => {
                                this.bindSubmitForm(formikBag.handleSubmit);
                                return (
                                    <Form>
                                        <div
                                            className={
                                                "form-group " +
                                                (editFieldName === "Client ID" ? "visible" : "hide")
                                            }
                                        >
                                            <label htmlFor="clientId" className="form-label">
                                                Client ID
                                            </label>
                                            <Field
                                                name="clientId"
                                                id="clientId"
                                                type="text"
                                                className="form-control"
                                                maxLength={30}
                                            />
                                            <ErrorMessage name="clientId" />
                                        </div>
                                        <div
                                            className={
                                                "form-group " +
                                                (editFieldName === "Region" ? "visible" : "hide")
                                            }
                                        >
                                            <label htmlFor="region" className="form-label">
                                                Region
                                            </label>
                                            <Field
                                                name="region"
                                                id="region"
                                                type="text"
                                                className="form-control"
                                                maxLength={30}
                                            />
                                            <ErrorMessage name="region" />
                                        </div>
                                        <div
                                            className={
                                                "form-group " +
                                                (editFieldName === "Location" ? "visible" : "hide")
                                            }
                                        >
                                            <label htmlFor="location" className="form-label">
                                                Location
                                            </label>
                                            <Field
                                                name="location"
                                                id="location"
                                                type="text"
                                                className="form-control"
                                                maxLength={30}
                                            />
                                            <ErrorMessage name="location" />
                                        </div>
                                        <div
                                            className={
                                                "form-group " +
                                                (editFieldName === "Unit" ? "visible" : "hide")
                                            }
                                        >
                                            <label htmlFor="unit" className="form-label">
                                                Unit
                                            </label>
                                            <Field
                                                name="unit"
                                                id="unit"
                                                type="text"
                                                className="form-control"
                                                maxLength={30}
                                            />
                                            <ErrorMessage name="unit" />
                                        </div>
                                        <div
                                            className={
                                                "form-group " +
                                                (editFieldName === "Project" ? "visible" : "hide")
                                            }
                                        >
                                            <label htmlFor="projectId" className="form-label">
                                                Project ID
                                            </label>
                                            <Field
                                                name="projectId"
                                                id="projectId"
                                                type="text"
                                                className="form-control"
                                            />
                                            <ErrorMessage name="projectId" />
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                        <SilErrorMessage message={this.state.upsertResponse} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.handleSave}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );
    }
}
